import { ConfigProvider, message, type ModalFuncProps, notification } from 'antd'
import { type ModalFunc } from 'antd/lib/modal/confirm'
import React, { type HTMLAttributes, useEffect, useRef, type PropsWithChildren } from 'react'

// 兼容 Ant Design
export function AntdProvider(props: PropsWithChildren<unknown>) {
  const anchorRef = useRef<HTMLDivElement>(null)
  const getRootContainer = () => {
    const shadowroot = anchorRef.current?.getRootNode()
    // 把默认在 body 上挂载的组件，改为挂载在当前应用的根节点下, 解决挂载的组件没有样式的问题
    if (window.__POWERED_BY_QIANKUN__ && shadowroot) {
      return shadowroot as HTMLElement
    }
    return document.body
  }
  // 由于静态方法不能消费上下文, 使用静态方法配置
  useEffect(() => {
    message.config({
      getContainer: getRootContainer
    })
    notification.config({
      getContainer: getRootContainer
    })
  }, [])
  return (
    <ConfigProvider getPopupContainer={getRootContainer} getTargetContainer={getRootContainer}>
      {props.children}
      <div ref={anchorRef} />
    </ConfigProvider>
  )
}

export function withModalRootContainer(modalFunc: ModalFunc) {
  return (props: ModalFuncProps) => {
    modalFunc({
      ...props,
      getContainer() {
        if (window.__POWERED_BY_QIANKUN__ && window.qiankunProps?.container) {
          return window.qiankunProps.container
        }
        return document.body
      },
    })
  }
}

// 事件从 ShadowDOM 中触发时, ev.target 可能会被 Retarget, 导致无法聚焦表单组件
// 这通常发生在自定义表单内容render时, 比如 Select 的 dropdownRender
// 阻止冒泡并且拿到实际的事件目标进行聚焦, 可以解决这个问题
export function overrideShadowDomEvents() {
  if (window.__POWERED_BY_QIANKUN__) {
    return {
      onMouseDown: (ev) => {
        ev.stopPropagation()
        ev.currentTarget.focus()
      },
    } as Pick<HTMLAttributes<HTMLElement>, 'onMouseDown'>
  }
  return {}
}
